function ucwords(str){
    str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
    });

    return str;
}

function getHomeURL(){
    const queryString = window.location.search ?? '';
    const urlParams = new URLSearchParams(queryString);
    //let url = 'https://donate.worldvision.org.ph/c/level-up' + queryString
    let url = window.location.origin;

    if(queryString){
        const urlParams = new URLSearchParams(queryString);
        const home_url = urlParams.get('home')

        if(home_url){
            url = home_url
        }
    }

    return url
}

function getURLParams(param = ''){
    const queryString = window.location.search ?? '';
    let url = window.location.origin;
    let amount = ''
    let method = ''

    if(queryString){
        const urlParams = new URLSearchParams(queryString);
        //amount = urlParams.get('amount')
        //method = urlParams.get('method')

        return urlParams.get(param)
    }

    return
}
    
function filterObject(data = [], filter, filter_by = 'id') {
    if(data.length){
        return data.find(item => item[filter_by] == filter)
    }
    else{
        return
    }
}

function detectType(value) {
  const type = typeof value;

  if (value === null) return 'null';
  if (Array.isArray(value)) return 'array';
  if (type === 'object') {
    if (value instanceof Date) return 'date';
    if (value instanceof Set) return 'set';
    if (value instanceof Map) return 'map';
  }

  return type;
}

const isItemAlreadyAdded = (array, target, keys = ['id', 'value']) => {
    return array.some(item => keys.some(key => item[key] === target[key]));
};

const sumByKey = (items, key) => {
  return items.reduce((total, item) => {
    const num = Number(item[key]);
    return total + (isNaN(num) ? 0 : num);
  }, 0);
};

const combineProperty = (addons, key) => {
  return addons
    .map(item => item[key]?.trim())
    .filter(Boolean)
    .join(', ');
};

const formatAddons = (addons) => {
  if (!Array.isArray(addons)) return '';

  return addons
    .map(item => {
      let label = item.label?.trim() || '';

        //   // Optional: shorten "Birthday Gift" to "Birthday"
        //   if (label.toLowerCase() === 'birthday gift') {
        //     label = 'Birthday';
        //   }

      return `${label} (₱${item.value})`;
    })
    .join(', ');
};


const helpers = {
    ucwords,
    getHomeURL,
    getURLParams,
    filterObject,
    detectType,
    isItemAlreadyAdded,
    sumByKey,
    combineProperty,
    formatAddons
}

export default helpers;